import React, { useEffect } from 'react'
import { IdPathFlowQuestionDefinition } from '#src/components/Path/Question'
import { IdPathFlowQuestionType } from '#src/generated/graphql'
import MediaUploadQuestion from './MediaUploadQuestion'
import ExpertSelectionQuestion from './ExpertSelectionQuestion'

export interface IdQuestionProps extends IdPathFlowQuestionDefinition<{}> {}

const IdPathFlowQuestion: React.SFC<IdPathFlowQuestionDefinition<{}>> = ({
  question,
  onFieldValidityChanged,
  onFieldValueChanged,
  ...rest
}) => {
  useEffect(() => {
    if (question.idUserInput.value) {
      onFieldValidityChanged(true)
      onFieldValueChanged({
        value: question.idUserInput.value
      })
    }

    if (!question.required) {
      onFieldValidityChanged(true)
    }
  }, [])

  switch (question.idType) {
    case IdPathFlowQuestionType.MEDIA_ID_IMAGE_UPLOAD:
      return (
        <MediaUploadQuestion
          question={question}
          onFieldValidityChanged={onFieldValidityChanged}
          onFieldValueChanged={onFieldValueChanged}
          {...rest}
        />
      )

    case IdPathFlowQuestionType.EXPERT_ID_SELECTION:
      return (
        <ExpertSelectionQuestion
          question={question}
          onFieldValidityChanged={onFieldValidityChanged}
          onFieldValueChanged={onFieldValueChanged}
          {...rest}
        />
      )

    default:
      throw new Error(`Unrecognized id type question initialized, [${IdPathFlowQuestionType}]`)
  }
}

export default IdPathFlowQuestion
